<!--
 * @Author: MouXiaowei
 * @Date: 2022-07-26 09:57:17
 * @Description: 中石油优惠券抢券活动页面
-->

<template>
  <div class="home-box">
      <div class="coupon-box">
          <div class="coupon-title">每日9点限量领取</div>
          <div v-for="(item, index) in couponList" :key="index">
              <div class="coupon-content">
                  <div class="coupon-content-left">
                      <div class="coupon-content-left-unit">¥</div>
                      <div class="coupon-content-left-value">{{formatMoney(item.batchMoney)}}</div>
                  </div>
                  <div class="coupon-content-right">
                      <div class="coupon-content-right-desc">
                          <div class="coupon-content-right-desc-title">{{item.showTitle}}</div>
                          <div class="coupon-content-right-desc-limit">{{'（满' + formatMoney(item.limitMoney) + '元可用1张）'}}</div>
                      </div>
                      <div v-if="item.state === 1" class="coupon-content-right-btn" @click="handleGrand(item.id)">立即领取</div>
                      <div v-else-if="item.state === 3"  class="coupon-content-right-clear">今日已抢光</div>
                      <div v-else-if="item.state === 2"  class="coupon-content-right-got">已领取</div>
                      <div v-else class="coupon-content-right-nostart">还未开始</div>
                  </div>
              </div>
          </div>
      </div>

      <div class="rule-box">
          <div class="rule-title">活动规则</div>
          <div class="rule-content">
              <p>1.用户点击“立即领取”可获得1张加油电子优惠券。活动期间，每位用户每种面额的优惠券仅限领取1次。</p>
              <p>2.库存每天上午9:00自动更新，每天发完即止。</p>
              <p>3.活动有效期自2022年7月29日 - 8月4日。</p>
              <p>4.加油优惠券限时有效（有效期以优惠券详情显示为准），尽快使用，过期不予补发噢～</p>
          </div>
      </div>

      <div class="station-box">
          <div class="station-btn" @click="gotoSNPStationPage">点击查看加油站可用站点</div>
          <div class="station-tip">没抢到的车主伙伴们不要灰心，优惠力度更大的活动即将揭晓，敬请期待！</div>
      </div>

      <div class="use-box">
          <div class="use-title">加油优惠券使用规则</div>
          <div class="use-content">
              <p>1.加油券领取后可在“便捷青岛APP--首页--卡券包”中查看及使用。您也可以登陆“中油好客e站”小程序或“中油好客e站”APP进行查看使用。</p>
              <p>2.仅限山东省内中国石油青岛自营加油站使用，高速路站不能使用（点击上方链接查看加油站可用站点）。</p>
              <p>3.加油券有效期以券面显示为准，请在有效期内使用。</p>
              <p>4.使用路径：便捷青岛 APP--首页--卡券包--线下向收银员出示券码--收银员核销成功--使用微信/支付宝/现金等方式支付优惠后实付金额。</p>
              <p>5.同一APP账号、同一手机号、同一自然人，满足任一条件视为同一用户。</p>
              <p>6.同一用户每次消费限用1张，每天仅限使用1张（因不同门店可能存在优惠活动的情况，使用前需确保加油实付金额大于优惠券使用门槛）。</p>
              <p>7.本券不可提现, 不设找零，截屏、复制、修改、转发无效，过期作废。</p>
              <p>8.使用前请向收银员出示本券码；本券不可通过自助加油机进行核销。</p>
              <p>9.本券不与除挂牌机价直降、加油卡折扣之外的其他优惠同时使用。</p>
              <p>10.如有疑问，请咨询中国石油山东省青岛市自营加油站。</p>
              <p>11.为保证本券的正常使用，优惠码页面每1分钟自动刷新，若遇使用失败，可手动点击二维码刷新。</p>
          </div>
      </div>
  </div>
</template>
<script>

import { setStore } from '@/utils/index'
import { getSeckillList, requestGrantTime } from '@/api/coupon'
import { Toast } from 'vant'

export default {
  name: 'couponSnpActive',
  components: {
  },
  data () {
    return {
      couponList: [],
      timer: null, // 轮询支付结果定时器
      timerLoopCount: 0 // 定时器轮询次数
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  mounted () {
    const accessToken = this.$route.query.accessToken
    if (accessToken) {
      setStore('token', accessToken)
    }
    this.queryCouponList()
  },
  methods: {
    // 优惠券领取接口
    handleGrand (id) {
      const queryList = {
        id: id
      }
      requestGrantTime(queryList).then(res => {
        if (res && res.data && res.data.code === 200) {
          Toast({
            message: '领取成功'
          })
          this.queryCouponList()
        } else {
          this.queryCouponList()
        }
      }).catch(() => {
        this.queryCouponList()
      })
    },
    // 查询签到信息请求
    queryCouponList () {
      const queryList = {
      }
      getSeckillList(queryList).then(res => {
        if (res && res.data) {
          const datas = res.data.result
          this.couponList = datas.couponSeckillVos
          this.end()
          if (this.couponList.length > 0) {
            const remainTime = this.couponList[0].remainTime
            if (remainTime != null) {
              this.timerLoopCount = Number(remainTime)
              this.start()
            }
          }
        }
      }).catch(() => {
        this.queryCouponList()
      })
    },
    formatMoney (money) {
      if (money == null) return 0
      return money.toFixed(0)
    },
    gotoSNPStationPage () {
      this.$router.push('/couponSnpActiveStation')
    },
    // 开启定时器
    start () {
      this.timer = setInterval(() => {
        this.timerLoopCount -= 1
        if (this.timerLoopCount <= 1) {
          this.queryCouponList()
        }
      }, 1000)
    },
    // 结束定时器
    end () {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.home-box {
    position: relative;
    min-height: 100vh;
    height: 100%;
    background: #f44d29 url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/coupon/coupon_snp_active_bg2.png') no-repeat;
    background-size: 100%;
    overflow-x: hidden;
}

.coupon-box {
    margin-top: 125%;
    margin-left: 12.5px;
    margin-right: 12.5px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .coupon-title {
        margin-bottom: 10px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
    }
    .coupon-content {
        background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/coupon/coupon_snp_coupon_bg.png') no-repeat;
        width: 350px;
        height: 60px;
        overflow-x: hidden;
        margin-top: 12.5px;
        display: flex;
        flex-direction: row;

        .coupon-content-left {
            width: 90px;
            height: 60px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            &-unit {
                height: 24px;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                color: #F65A30;
                font-size: 12px;
                font-weight: 900;
            }
            &-value {
                margin-left: 3px;
                color: #F65A30;
                font-size: 28px;
                font-weight: 900;
            }
        }
        .coupon-content-right {
            width: 260px;
            height: 60px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .coupon-content-right-desc {
                width: 150px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .coupon-content-right-desc-title {
                    color: #F65A30;
                    font-size: 13px;
                    font-weight: 400;
                }
                .coupon-content-right-desc-limit {
                    margin-top: 6px;
                    color: #333233;
                    font-size: 13px;
                    font-weight: 500;
                }
            }
            // 可领取
            .coupon-content-right-btn {
                margin-right: 18px;
                width: 90px;
                height: 30px;
                border-radius: 15px;
                background: rgba(246,90,48,1);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 13px;
                font-weight: 400;
            }
            // 未开始
            .coupon-content-right-nostart {
                margin-right: 18px;
                width: 90px;
                height: 30px;
                border-radius: 15px;
                background: rgba(255,177,156,1);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 13px;
                font-weight: 400;
            }
            // 已抢光
            .coupon-content-right-clear {
                margin-right: 18px;
                width: 90px;
                height: 30px;
                border-radius: 15px;
                background: rgba(224,224,224,1);
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 13px;
                font-weight: 400;
            }
            // 已领取
            .coupon-content-right-got {
                margin-right: 18px;
                width: 90px;
                height: 30px;
                border-radius: 15px;
                border: 1px solid #F65A30;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #F65A30;
                font-size: 13px;
                font-weight: 400;
            }
        }
    }
}

.rule-box {
    margin-top: 21px;
    margin-left: 12.5px;
    margin-right: 12.5px;

    .rule-title {
        width: 100px;
        height: 26.5px;
        border-radius: 16px 0px 32px 0px;
        background: rgba(252,232,186,1);
        font-weight: 400;
        font-size: 16px;
        color: #F65C31;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .rule-content {
        margin-top: 18px;
        font-weight: 400;
        font-size: 13px;
        color: #fff;
        line-height: 20px;
    }
}

.station-box {
    margin-top: 28px;
    margin-left: 12.5px;
    margin-right: 12.5px;

    .station-btn {
        height: 40px;
        border-radius: 5px;
        background: rgba(255,255,255,1);
        font-weight: 500;
        font-size: 15px;
        color: #333233;
        line-height: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .station-tip {
        margin-top: 10px;
        font-weight: 400;
        font-size: 11px;
        color: #fff;
        line-height: 15px;
    }
}

.use-box {
    margin: 28px 12.5px;
    .use-title {
        width: 180px;
        height: 26.5px;
        border-radius: 16px 0px 32px 0px;
        background: rgba(252,232,186,1);
        font-weight: 400;
        font-size: 16px;
        color: #F65C31;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .use-content {
        margin-top: 18px;
        font-weight: 400;
        font-size: 13px;
        color: #fff;
        line-height: 20px;
    }
}

</style>
